export const getActiveCategory = () => {
  try {
    if (typeof window !== "undefined" && window.location) {
      const path = window.location.pathname || "";
      if (path.includes("/livecasino")) return "livecasino";
      if (path.includes("/instant")) return "instant";
      if (path.includes("/slot")) return "slot";
    }
  } catch (error) {
    console.error("Error getting active category:", error);
  }
  return "slot";
};

export const PROVIDERS = [
  {
    id: "theearcasino",
    label: "The Ear Casino",
    initials: "TEC",
    get logo() {
      const category = getActiveCategory() || "slot";
      return `https://storage.googleapis.com/camasy-images/theearcasino/logo_promotool_${category}.png`;
    },
    description: "The Ear Casino Platform",
    sublabel: "theearcasino",
    url: "https://theearcasino.theearplatform.com/",
  },
  {
    id: "studiocasinolab",
    label: "Studio Casino Lab",
    initials: "SCL",
    get logo() {
      const category = getActiveCategory() || "slot";
      return `https://storage.googleapis.com/camasy-images/studiocasinolab/logo_promotool.png`;
    },
    description: "Studio Casino Lab Platform",
    sublabel: "studiocasinolab",
    url: "https://theearcasino.theearplatform.com/studiocasinolab",
  },
];

export const getActiveProviderSlug = () => {
  // return 'studiocasinolab'
  return (
    localStorage.getItem("vue_app_provider_override") ||
    process.env.VUE_APP_PROVIDER ||
    "theearcasino"
  );
};

export const getActiveProvider = () => {
  const currentSlug = getActiveProviderSlug();
  const provider =
    PROVIDERS.find((p) => p.id === currentSlug) ||
    PROVIDERS[0];
  const category = getActiveCategory() || "slot";
  return {
    ...provider,
    logo: `https://storage.googleapis.com/camasy-images/${provider.id}/logo_promotool_${category}.png`,
  };
};

export const applyProviderBodyClass = (providerId) => {
  const targetId = providerId || getActiveProviderSlug();
  PROVIDERS.forEach((p) => {
    document.body.classList.remove(`provider_${p.id}`);
  });
  document.body.classList.add(`provider_${targetId}`);
};

export const switchProvider = (providerId) => {
  const targetProvider = PROVIDERS.find((p) => p.id === providerId);
  if (!targetProvider) return;

  const currentSlug = getActiveProviderSlug();
  if (providerId === currentSlug) return;

  window.location.href = targetProvider.url;
};
